import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

// Custom Diamond Bullet Component matching user screenshots
const DiamondBullet = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className="me-2 flex-shrink-0 mt-1"
    style={{ color: "#0D4AFF" }}
  >
    {/* Top Diamond */}
    <path d="M8 1 L10 4 L8 7 L6 4 Z" fill="currentColor" />
    {/* Bottom Diamond */}
    <path d="M8 9 L10 12 L8 15 L6 12 Z" fill="currentColor" />
    {/* Left Diamond */}
    <path d="M1 8 L4 10 L7 8 L4 6 Z" fill="currentColor" />
    {/* Right Diamond */}
    <path d="M9 8 L12 10 L15 8 L12 6 Z" fill="currentColor" />
  </svg>
);

export default function ProductDetails() {
  const [activeTab, setActiveTab] = useState("payment-gateway");
  const [theme, setTheme] = useState("light");
  const [faqOpenIndex, setFaqOpenIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Sync theme with HTML data-theme attribute
  useEffect(() => {
    const currentTheme =
      document.documentElement.getAttribute("data-theme") || "light";
    setTheme(currentTheme);

    const observer = new MutationObserver(() => {
      const newTheme =
        document.documentElement.getAttribute("data-theme") || "light";
      setTheme(newTheme);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  const productsData = {
    "payment-gateway": {
      //   title: { normal: "CRYPTO CURRENCY", highlight: "EXCHANGE" },
      title: "CRYPTO PAYMENT GATEWAY",
      category: "Payment Solutions",
      iconClass: "fa-solid fa-credit-card",
      description:
        "Our blockchain-based payment gateway facilitates fast, secure, and efficient transactions. It supports multiple cryptocurrencies, providing flexibility and convenience for our clients. Our payment gateway integrates seamlessly with e-commerce platforms and can be customized to suit specific business requirements.",
      features: [
        "Multi-chain Support",
        "High-speed Transactions",
        "Crypto-Wallet Integration",
        "Seamless Integration",
        "Secure and easy Payout",
      ],
      image: "assets/images/tokencoin/coin_hero2.webp",
      //   specs: [
      //     { label: "Tx Speed", value: "Instant settlement confirmations" },
      //     {
      //       label: "Supported Assets",
      //       value: "BTC, ETH, USDT, USDC, & 100+ altcoins",
      //     },
      //     {
      //       label: "Integration Formats",
      //       value: "REST APIs, Shopify/WooCommerce plugins, SDKs",
      //     },
      //     {
      //       label: "Compliance",
      //       value: "AML/KYC integrations, Transaction monitoring",
      //     },
      //     { label: "Custody Model", value: "Multi-sig payout system" },
      //   ],
      faqs: [
        {
          q: "Are transaction fees customizable?",
          a: "Yes, you can set custom gas overrides, charge fee margins on payments, or set free tiers for VIP users.",
        },
        {
          q: "How are conversions to stablecoins managed?",
          a: "Payments are settled directly in stablecoins (USDT/USDC) to mitigate cryptocurrency volatility during transactions.",
        },
      ],
    },
    "crypto-exchange": {
      title: "CRYPTO CURRENCY EXCHANGE",
      category: "Trading Platforms",
      iconClass: "fa-solid fa-arrow-right-arrow-left",
      description:
        "Blockcryp's Crypto Currency Exchange provides a secure and user-friendly platform for seamless trading. With robust features like advanced security protocols, diverse asset support, and real-time analytics, we empower users to navigate the crypto market effortlessly.",
      features: [
        "Multiple Trading Pair",
        "User-friendly Interface",
        "Advanced Charting Tools",
        "Mobile Accessibility",
        "Secure Trading Environment",
      ],
      image: "assets/images/cryptocurrency/crypto_hero2.webp",
      //   specs: [
      //     { label: "Engine Speed", value: "50,000 orders/sec per pair" },
      //     {
      //       label: "Security Setup",
      //       value: "Cold/Hot wallet isolation, 2FA, SMS Auth",
      //     },
      //     { label: "Trading Modes", value: "Spot, Margin, Perpetual Futures" },
      //     {
      //       label: "Analytics",
      //       value: "TradingView Charts, AI Trend predictors",
      //     },
      //     { label: "API Access", value: "WebSockets, REST Trading APIs" },
      //   ],
      faqs: [
        {
          q: "Do you provide white-label deployment?",
          a: "Yes, our cryptocurrency exchange solution is fully white-labeled, allowing you to custom brand the UI layout, colors, and logos.",
        },
        {
          q: "Is KYC/AML integrated with the exchange?",
          a: "Yes, we have out-of-the-box integrations with standard KYC providers like Sumsub, Ondato, or Jumio.",
        },
      ],
    },
    "nft-marketplace": {
      title: "METAVERSE NFT MARKETPLACE",
      category: "Metaverse & NFTs",
      iconClass: "fa-solid fa-store",
      description:
        "Our NFT marketplace is a comprehensive platform that enables users to create, buy, and sell NFTs. We facilitate the trading of a diverse array of digital assets, such as art, music, and virtual real estate, thereby enhancing their value.",
      features: [
        "Impressive Experience",
        "Augmented Reality (AR)",
        "Secure Transactions",
        "Community Features",
        "3D Asset Trades",
        "Royalty and Revenue",
      ],
      image: "assets/images/nftmarketplace/nft_hero.webp",
      //   specs: [
      //     { label: "Standards", value: "ERC-721, ERC-1155, dNFTs" },
      //     {
      //       label: "Royalties",
      //       value: "EIP-2981 dynamic royalties, multi-receiver split",
      //     },
      //     {
      //       label: "Auction Types",
      //       value: "Fixed Price, English Auction, Dutch Auction",
      //     },
      //     {
      //       label: "Minting Modes",
      //       value: "Lazy minting (gasless), batch minting",
      //     },
      //     {
      //       label: "Fiat Gateway",
      //       value: "Stripe, MoonPay, Transak integrations",
      //     },
      //   ],
      faqs: [
        {
          q: "What payment options are supported?",
          a: "Users can purchase NFTs with cryptocurrencies, stablecoins, or traditional credit cards via integrated fiat gateways.",
        },
        {
          q: "Can we support virtual real estate trades?",
          a: "Yes, our marketplace supports 3D mapping visualizers to view and trade virtual land coordinates directly.",
        },
      ],
    },
    metaverse: {
      title: "METAVERSE",
      category: "Metaverse & NFTs",
      iconClass: "fa-solid fa-vr-cardboard",
      description:
        "We are at the forefront of developing immersive metaverse experiences. Our metaverse solutions offer interactive virtual environments powered by blockchain technology. Users can explore, interact, and create in our metaverse, offering endless possibilities.",
      features: [
        "AI Infrastructure",
        "Interactive Experiences",
        "User-generated Content",
        "Spatial computing",
        "Blockchain Integration",
      ],
      image: "assets/images/metaverse/metaverse_hero2.webp",
      //   specs: [
      //     { label: "Graphics Engines", value: "WebGL, Unity, Unreal Engine 5" },
      //     {
      //       label: "Multiplayer Network",
      //       value: "WebSockets / WebRTC real-time sync",
      //     },
      //     { label: "Physics Engine", value: "Authoritative server-side physics" },
      //     {
      //       label: "Customizability",
      //       value: "Avatars, wearable digital items, emotes",
      //     },
      //     {
      //       label: "Hosting Config",
      //       value: "Scalable Kubernetes clusters, global edge nodes",
      //     },
      //   ],
      faqs: [
        {
          q: "Is there virtual store integration inside the metaverse?",
          a: "Yes, e-commerce gateways can be embedded inside the metaverse to link virtual item purchases with real-world shipping.",
        },
        {
          q: "What are the server hosting requirements?",
          a: "We provide scalable server configurations to handle thousands of concurrent players with low latency.",
        },
      ],
    },
    blockchain: {
      title: "BLOCKCHAIN",
      category: "Layer-1 & Layer-2 Networks",
      iconClass: "fa-solid fa-link",
      description:
        "We offer a service to develop a bespoke blockchain made for your specific needs. Our custom blockchain ensures secure, transparent, and efficient transactions. It’s designed to be scalable and interoperable, with the ability to integrate smart contracts. This service revolutionizes your business operations by enabling peer-to-peer transactions without intermediaries.",
      features: [
        "High TPS",
        "Low Fees",
        "Enhanced Security",
        "Scalability",
        "Customizability",
        "Interoperability",
        "Smart Contract Integration",
      ],
      image: "assets/images/blockchain/block_hero3.webp",
      //   specs: [
      //     {
      //       label: "Consensus Model",
      //       value: "Proof of Stake (PoS) / Proof of Authority (PoA)",
      //     },
      //     { label: "Block Times", value: "1 - 3 seconds block time" },
      //     { label: "VM Engine", value: "EVM (Solidity) / WASM compatibility" },
      //     {
      //       label: "Validator Node Config",
      //       value: "Kubernetes deployments, Multi-region",
      //     },
      //     {
      //       label: "SDK Framework",
      //       value: "Substrate / Cosmos SDK / custom Go-Ethereum",
      //     },
      //   ],
      faqs: [
        {
          q: "Can we host our own validator nodes?",
          a: "Yes, our architecture allows private validator nodes to be hosted across cloud environments (AWS, GCP) or private bare-metal servers.",
        },
        {
          q: "Is a custom blockchain explorer included?",
          a: "Yes, we provide a full-featured block explorer interface similar to Etherscan to track blocks, tokens, and transactions.",
        },
      ],
    },
    wallet: {
      title: "WALLET",
      category: "Asset Management",
      iconClass: "fa-solid fa-wallet",
      description:
        "Our digital wallet provides a secure environment for storing, managing, and transferring cryptocurrencies. It is user-friendly and supports a wide range of digital currencies. Our wallet ensures the safe storage of your digital assets and provides easy access whenever you need it.",
      features: [
        "Multi-currency Support",
        "Secure Storage",
        "Easy Access",
        "User-friendly Interface",
        "Non-custodial Wallet",
      ],
      image: "assets/images/tokencoin/Frame 223.webp",
      //   specs: [
      //     {
      //       label: "Security Level",
      //       value: "Biometric Auth, Secure Enclave, MPC keys",
      //     },
      //     {
      //       label: "Platform Availability",
      //       value: "iOS, Android, Chrome Web Extension",
      //     },
      //     {
      //       label: "Recovery System",
      //       value: "Social recovery, cloud-encrypted mnemonics",
      //     },
      //     {
      //       label: "Gas Management",
      //       value: "Auto gas fee optimization, gasless swaps",
      //     },
      //     { label: "dApp Browser", value: "Integrated Web3 browser engine" },
      //   ],
      faqs: [
        {
          q: "Is it a custodial or non-custodial wallet?",
          a: "It is 100% non-custodial. The user maintains complete control of their private keys and seed phrases; no keys are stored on our servers.",
        },
        {
          q: "Can we integrate custom tokens?",
          a: "Yes, standard tokens (ERC-20, SPL, etc.) can be loaded automatically or added manually using contract addresses.",
        },
      ],
    },

    "dex-exchange": {
      title: " DEX EXCHANGE",
      category: "DeFi Solutions",
      iconClass: "fa-solid fa-right-left",
      description:
        "We have the capability to develop a decentralized exchange (DEX) on any blockchain as per your requirements. Our DEX facilitates direct peer-to-peer transactions, giving users complete control over their funds and transactions. By eliminating intermediaries, we ensure maximum security and efficiency. We've successfully created several DEXs in the past, demonstrating our expertise and experience in this domain.",
      features: [
        "No Intermediaries",
        "Full Control Over Funds",
        "High Security",
        "Efficient Transactions",
      ],
      image: "assets/images/exchange/exchange_hero2.webp",
      //   specs: [
      //     { label: "Throughput (TPS)", value: "Up to 15,000+ tx/sec" },
      //     { label: "Execution Latency", value: "< 100ms" },
      //     { label: "Supported Standards", value: "ERC-20, BEP-20, SPL" },
      //     { label: "Asset Custody", value: "Non-custodial Smart Contracts" },
      //     {
      //       label: "Blockchains supported",
      //       value: "Ethereum, BSC, Polygon, Solana",
      //     },
      //   ],
      faqs: [
        {
          q: "Does this DEX exchange solution support liquidity aggregation?",
          a: "Yes, our DEX can integrate with standard AMM liquidity aggregators like 1inch or Paraswap to source the best rates across pools.",
        },
        {
          q: "What wallets are supported out-of-the-box?",
          a: "It includes full integration with MetaMask, WalletConnect, Coinbase Wallet, Trust Wallet, and Phantom.",
        },
      ],
    },
    "custom-dapps": {
      title: "CUSTOM DAPPS",
      category: "Web3 Development",
      iconClass: "fa-solid fa-cubes",
      description:
        "We specialize in developing custom decentralized applications (DApps) that are secure, scalable, and efficient. Our DApps are designed to meet the unique needs of our clients, providing solutions that drive business growth and innovation.",
      features: [
        "Global Availability",
        "Secure and Scalable",
        "Efficient Performance",
        "Consensus mechanisms",
        "Ongoing Support and Maintenance",
      ],
      image: "assets/images/defi/defi_hero.webp",
      //   specs: [
      //     { label: "Architecture", value: "Decentralized, Event-driven APIs" },
      //     { label: "Smart Contracts", value: "Audited Solidity / Rust" },
      //     {
      //       label: "Frontend Stack",
      //       value: "React, Next.js, Web3.js, Ethers.js",
      //     },
      //     { label: "Database Layer", value: "IPFS / Arweave for metadata" },
      //     { label: "Upgradeability", value: "Proxy Pattern smart contracts" },
      //   ],
      faqs: [
        {
          q: "Can you design custom smart contracts for our DApp?",
          a: "Yes, our team specializes in custom smart contracts written in Solidity and Rust, complete with formal verification and gas optimization.",
        },
        {
          q: "How do you handle DApp maintenance?",
          a: "We provide comprehensive support, contract upgrade monitoring, node infrastructure monitoring, and regular frontend updates.",
        },
      ],
    },
    "ai-development": {
      title: "AI DEVELOPMENT",
      category: "Artificial Intelligence",
      iconClass: "fa-solid fa-robot",
      description:
        "We offer custom AI development services tailored to your specific needs. Whether you need an AI to automate processes, gain insights from data, or enhance user experiences, we have the skills and expertise to make it happen. We follow a collaborative approach, working closely with you to understand your needs and deliver solutions that provide real value.",
      features: [
        "Customized AI Solutions",
        "End-to-End Development",
        "Interoperability",
        "Predictive Analysis",
        "Deep Learning",
        "Chatbot Development",
        "Personalization",
      ],
      image: "assets/images/aidevelopment/ai_hero.webp",
      //   specs: [
      //     { label: "Core Frameworks", value: "PyTorch, TensorFlow, LangChain" },
      //     { label: "Integration", value: "REST APIs, Web3 Smart Contracts" },
      //     {
      //       label: "Models Supported",
      //       value: "GPT-4, Claude 3, Llama 3, Custom LLMs",
      //     },
      //     { label: "Latency", value: "Sub-second response times" },
      //     { label: "Data Security", value: "Isolated VPC, encrypted inputs" },
      //   ],
      faqs: [
        {
          q: "How are AI agents integrated with Web3 or blockchain?",
          a: "Our AI agents can monitor on-chain events, execute trades using smart contract APIs, and manage token distributions automatically.",
        },
        {
          q: "Do you provide model training on custom corporate data?",
          a: "Yes, we build secure data ingestion pipelines to train or fine-tune models on your proprietary datasets without leaking data.",
        },
      ],
    },
  };

  const activeProduct = productsData[activeTab];

  return (
    <>
      <Helmet>
        <title>
          {activeProduct
            ? `${activeProduct.title} Solutions | Blockcryp`
            : "Product Details | Blockcryp"}
        </title>
        <meta
          name="description"
          content={
            activeProduct
              ? activeProduct.description.substring(0, 155)
              : "Discover the range of enterprise blockchain, Web3, and AI products developed by Blockcryp."
          }
        />
        <meta
          name="keywords"
          content="blockcryp products, dex exchange development, custom dapps, ai development, crypto payment gateway, crypto exchange software, private blockchain, non-custodial wallet, metaverse marketplace, virtual world development"
        />
      </Helmet>

      {/* -------------------hero section start ------------- */}

      <section className="hero position-relative space100 product_hero">
        <div className="container h-100">
          <div className="row justify-content-center h-100">
            <div className="col-xl-8 col-lg-10 col-12 h-100 d-flex flex-column justify-content-center">
              <motion.h1
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h1 text-center fw-bold text-light mb-3"
                style={{ color: "var(--text-dark)", letterSpacing: "-1.5px" }}
              >
                Enterprise Product Suite
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 1,
                  delay: 0.1,
                  ease: "easeInOut",
                }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt mb-0 text-center"
              >
                Click a category below to explore technical capabilities,{" "}
                <br className="d-none d-xl-block"></br>
                specifications, and live inquiries.
              </motion.p>
            </div>
          </div>
        </div>
      </section>
      {/* ---------------- Hero Section end ---------- */}

      {/* --------- Main Content Section start ---- */}
      <div className="product_details_section space100 ">
        <div className="container">
          <div className="row g-xl-5 g-lg-4 g-4 align-items-start justify-content-center">
            <div className="col-lg-4 sticky_section">
              <motion.h4
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
                className="fw-bold mb-lg-4 mb-2"
                style={{ color: "var(--text-dark)" }}
              >
                Our Product List
              </motion.h4>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
                className="product_sidebar_container h-100"
              >
                {Object.keys(productsData).map((key) => {
                  const prod = productsData[key];
                  const isActive = activeTab === key;
                  return (
                    <div
                      key={key}
                      className={`product_sidebar_card ${isActive ? "active" : ""}`}
                      onClick={() => {
                        setActiveTab(key);
                        setFaqOpenIndex(null);
                      }}
                    >
                      <div className="product_icon_box">
                        <i className={prod.iconClass}></i>
                      </div>
                      <div className="flex-grow-1 overflow-hidden">
                        <span
                          className="d-block text-uppercase fw-medium mb-1"
                          style={{
                            fontSize: "0.75rem",
                            letterSpacing: "0.5px",
                            color: isActive
                              ? "var(--text-primary)"
                              : "var(--text-secondary)",
                          }}
                        >
                          {prod.category}
                        </span>
                        <h6
                          className="mb-0 text-truncate fw-bold"
                          style={{
                            color: "var(--text-dark)",
                            fontSize: "0.95rem",
                          }}
                        >
                          {prod.title}
                        </h6>
                      </div>
                      <div className="ms-2">
                        <i
                          className={`fa-solid fa-angle-right ${isActive ? "text-primary" : "text-muted"}`}
                          style={{
                            transform: isActive ? "translateX(2px)" : "none",
                            transition: "all 0.2s ease",
                          }}
                        ></i>
                      </div>
                    </div>
                  );
                })}
              </motion.div>
            </div>

            <div className="col-lg-8 mt-3">
              <AnimatePresence mode="wait">
                <div
                  key={activeTab}
                  // initial={{ opacity: 0, y: 15 }}
                  // animate={{ opacity: 1, y: 0 }}
                  // exit={{ opacity: 0, y: -15 }}
                  // transition={{ duration: 1, ease: "easeInOut" }}
                >
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="d-flex align-items-center mb-3"
                  >
                    <span className="productbadge px-3 py-2 text-uppercase">
                      {activeProduct.category}
                    </span>
                  </motion.div>
                  <motion.h2
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.1, ease: "easeInOut" }}
                    viewport={{ once: false, amount: 0.5 }}
                    // viewport={{ once: false, amount: 0.5 }}
                    className="heading_h3 fw-bold mb-4"
                  >
                    {activeProduct.title}
                  </motion.h2>
                  {/* <h2
                      className="heading_h1 fw-extrabold mb-4"
                      style={{
                        color: "var(--text-dark)",
                        letterSpacing: "-0.5px",
                      }}
                    >
                      {activeProduct.title}
                    </h2> */}

                  {/* Description Paragraph */}
                  <motion.p
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="pera_txt mb-5"
                  >
                    {activeProduct.description}
                  </motion.p>

                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.3, ease: "easeInOut" }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="mockup_image_wrapper mb-5 position-relative shadow-sm border_md overflow-hidden"
                  >
                    <ImageWithSkeleton
                      src={activeProduct.image}
                      alt={activeProduct.title}
                      height="500px"
                      className="w-100 h-100 object-fit-contain"
                    />
                  </motion.div>

                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.4, ease: "easeInOut" }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="features_slide_box mb-5"
                  >
                    <h5 className="features_slide_title">
                      Key Product Capabilities
                    </h5>
                    <div className="row">
                      {activeProduct.features.map((feature, idx) => (
                        <div className="col-md-6" key={idx}>
                          <div className="feature_bullet_item">
                            <DiamondBullet />
                            <span>{feature}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </motion.div>

                  {/* Product FAQs */}
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5, ease: "easeInOut" }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="faq_container mb-5"
                  >
                    <h5
                      className="fw-bold mb-4"
                      style={{ color: "var(--text-dark)" }}
                    >
                      Frequently Asked Questions
                    </h5>
                    {activeProduct.faqs.map((faq, idx) => {
                      const isOpen = faqOpenIndex === idx;
                      return (
                        <div key={idx} className="faq_accordion_item accordion">
                          <div
                            className="faq_accordion_header"
                            onClick={() => setFaqOpenIndex(isOpen ? null : idx)}
                          >
                            <span>{faq.q}</span>
                            <i
                              className={`fa-solid fa-chevron-down text-primary transition-all`}
                              style={{
                                transform: isOpen
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s ease",
                              }}
                            ></i>
                          </div>
                          <AnimatePresence initial={false}>
                            {isOpen && (
                              <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.5 }}
                                className="faq_accordion_body"
                              >
                                {faq.a}
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </div>
                      );
                    })}
                  </motion.div>
                </div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
      {/* --------- Main Content Section end ---- */}

      {/* --------------- cta start  ------------- */}
      <section className="cta space80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <div className="text-center">
                <motion.h2
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="text_70 mb-3 text-uppercase fw-semibold talk_heading text-primary"
                >
                  Tell Us Your New Ideas
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  a dynamic design excelling in transforming imaginative
                  concepts into vivid realities through{" "}
                  <br className="d-none d-lg-block"></br> innovative strategies
                  and compelling creative executions.
                </motion.p>

                <a
                  href="https://teams.live.com/l/invite/FEAgoDJPJi4z_OT7QI"
                  target="_blank"
                >
                  <motion.button
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    type="button"
                    className="button talk_btn home_btn theme_btn mt-3"
                  >
                    let's talk <i class="fa-solid fa-square-up-right ms-2"></i>
                  </motion.button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* --------------- cta end  ------------- */}
    </>
  );
}
